import React, { Component } from "react";

/**
 * Captura erros de renderização da árvore React.
 *
 * Sem isto, qualquer exceção durante o render derruba a aplicação inteira e o usuário
 * fica com a tela em branco, sem mensagem e sem forma de voltar.
 */
export default class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = { temErro: false };
        this.handleClickRecarregar = this.handleClickRecarregar.bind(this);
    }

    static getDerivedStateFromError() {
        return { temErro: true };
    }

    componentDidCatch(error, errorInfo) {
        //mantém o rastro no console do navegador para diagnóstico
        console.error("Erro não tratado na renderização:", error, errorInfo);
    }

    handleClickRecarregar() {
        window.location.reload();
    }

    render() {
        if (!this.state.temErro) {
            return this.props.children;
        }

        return (
            <div className="container my-5">
                <div className="alert alert-danger" role="alert">
                    <h5 className="alert-heading">Ocorreu um erro inesperado nesta tela</h5>
                    <p className="mb-3">
                        A operação anterior pode não ter sido concluída. Recarregue a página e, se o erro
                        continuar, informe ao suporte o que estava fazendo no momento.
                    </p>
                    <button type="button" className="btn btn-danger" onClick={this.handleClickRecarregar}>
                        Recarregar página
                    </button>
                </div>
            </div>
        );
    }
}
